module.exports = __webpack_public_path__ + "static/media/44493371_2199958196746026_2230715497106636800_o.9be23bbf.jpg";